import { Directive, HostListener } from '@angular/core';

import { PasswordUtils } from '../utils/password.utils';

@Directive()
export class PasswordTooltipDirective {
  showPasswordTooltip = false;
  passwordTooltipTop = '0';
  passwordTooltipLeft = '0';
  isPasswordTooltipFocused = false;

  @HostListener('window:keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    if (event.key === 'Escape' || event.key === 'Esc') {
      this.isPasswordTooltipFocused = false;
      this.showPasswordTooltip = false;
    }
  }

  @HostListener('window:mousedown')
  onMouseDown() {
    if (!this.isPasswordTooltipFocused) {
      this.showPasswordTooltip = false;
    }
  }

  onPasswordFocus(event: FocusEvent) {
    const elPosition = (event.target as HTMLElement).getBoundingClientRect();
    const scrollPosition = PasswordUtils.getScrollPosition();

    this.showPasswordTooltip = true;
    this.passwordTooltipTop = `${elPosition.top + scrollPosition.y + 55}px`;
    this.passwordTooltipLeft = `${elPosition.left + scrollPosition.x}px`;
  }

  onPasswordBlur() {
    if (!this.isPasswordTooltipFocused) {
      this.showPasswordTooltip = false;
    }
  }
}

